import * as React from "react";
const SvgFiRrLandLayers = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-land-layers_svg__a)">
      <path
        fill="#062147"
        d="m.485 8.088 9.862 5.917a3.21 3.21 0 0 0 3.306 0l9.86-5.917a1 1 0 0 0 0-1.714L13.654.456a3.21 3.21 0 0 0-3.307 0L.485 6.373a1 1 0 0 0 0 1.714zm12.139 4.202a1.21 1.21 0 0 1-1.25 0L8.25 10.415l3.749-2.249 3.748 2.25-3.124 1.873zm5.068-3.04L13.944 7l3.364-2.018 3.748 2.25zM11.376 2.17c.385-.23.863-.23 1.248 0l2.74 1.644L12 5.835l-3.364-2.02zM6.692 4.982 10.056 7 6.308 9.25 2.944 7.23zM.142 11.09a1 1 0 0 1 1.373-.343l9.86 5.917c.386.23.865.23 1.25 0l9.86-5.917a1 1 0 1 1 1.03 1.715l-9.861 5.917a3.21 3.21 0 0 1-3.306 0L.485 12.462a1 1 0 0 1-.343-1.372m23.716 4.295a1 1 0 0 1-.343 1.372l-9.861 5.917a3.2 3.2 0 0 1-3.307 0L.485 16.757a1 1 0 1 1 1.029-1.715l9.86 5.917c.386.23.865.23 1.249 0l9.862-5.917a1 1 0 0 1 1.373.343"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-land-layers_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLandLayers;
